import Vue from 'vue';
import Vuex from 'vuex';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    firebase: {
      user: null,
      error: null,
      loading: false,
    },
    app: {
      imageDomain: '/static/rics-megacity/assets/questions',
      documentDomain: '/static/rics-megacity/assets/documents',
    },
    user: {
      score: 0,
      budget: 130000000,
      rank: 1,
      showPromotion: false,
      gameOver: false,
      showTips: false,
      level: 1,
      question: 0,
      questionIndex: 0,
      // 1 = a lot / 2 = a little / 3 = some / 4 = nothing
      startConfidence: 0,
      // 1 = a lot / 2 = a little / 3 = some / 4 = nothing
      endConfidence: 0,
      // 1 = unlikely / 2 = likely / 3 = very likely
      pursueCareer: 0,
    },
    levels: [
      {
        level: 1,
        name: '~@/assets/images/characters/challenge-1.svg',
        intro: '<p>The development of Mega City has been given approval.</p>' +
                '<p>This city needs to attract investors, cater for a growing population and be sustainable.</p>' +
                '<p>Before plans and contracts can be agreed the site needs preparing...</p>',
        feedback: {
          avatar: '/avatar--level_1.png',
          background: '',
          from: 'cwilson@wilsonsurveyors.co.uk',
          welcome: 'Hi there,',
          signoff: 'Kind regards',
          name: 'Callum Wilson',
        },
      },
      {
        level: 2,
        name: '~@/assets/images/characters/challenge-2.svg',
        intro: '<p>The land is now prepared and ready for Mega City development.</p>' +
                '<p>The city needs to be planned in order to be sustainable and to best use the space available.</p>' +
                '<p>It needs to attract investment but also cater to a growing community.</p>',
        feedback: {
          avatar: '/avatar--level_2.png',
          background: '',
          from: ' j.slade@sladeandco.co.uk',
          welcome: 'Hi again,',
          signoff: 'Regards',
          name: 'Jeremy',
        },
      },
      {
        level: 3,
        name: 'challenge-3.svg',
        intro: '<p>With the land prepared and access to services well underway, Mega City now needs to attract investors and ultimately residents and businessess.</p>',
        feedback: {
          avatar: '/avatar--level_3.png',
          background: '',
          from: 'nadia.gomos@jwsurveyors.com',
          welcome: 'Hi there,',
          signoff: 'Best regards',
          name: 'Nadia',
        },
      },
      {
        level: 4,
        name: 'challenge-4.svg',
        intro: '<p>Mega City has been planned, designed and built. It now needs to become a smart city using data and technology to improve the quality of life for those living and working in the city.</p>',
        feedback: {
          avatar: '/avatar--level_4.png',
          background: '',
          from: 'holly.hughes@surveysrus.co.uk',
          welcome: 'Hello there,',
          signoff: 'Kind regards',
          name: 'Holly Hughes',
        },
      },
    ],
    questions: [
      {
        id: 1,
        level: 1,
        countInLevel: 1,
        text: 'As a <strong>Building Surveyor</strong> you have been asked to assess a historic building to see if it\'s energy efficient.  During a virtual reality tour of the building you find that it\'s in bad condition and not energy efficient. What would you recommend?',
        image: '/main--level_1_question_1.jpg',
        feedback_background: '/bg--level_1_new.jpg',
        feedbackTo: 'building.surveyor@megacity123.co.uk',
        feedbackSubject: 'Historic building recommendation',
        answered: false,
        answer: 0,
        responses: [
          {
            id: 1,
            text: 'Demolish the building. This would ensure the site is clear for development.',
            score: 2,
            cost: 10000,
            feedback: 'Thanks for your recommendation. Demolishing the building is a nice cheap option, however; it would reduce historic value within the city.',
          },
          {
            id: 2,
            text: 'Re-develop the building into a \'themed\' state-of-the-art museum within the walls of the current structure.',
            score: 3,
            cost: 500000,
            feedback: 'Thanks for your recommendation. Re-developing the building would be a costly option, but may be a good investment opportunity and would retain the history of the city.',
          },
          {
            id: 3,
            text: 'Leave the building as it is and build around it.',
            score: 1,
            cost: 0,
            feedback: 'Thanks for your recommendation. Leaving the building as it is would be the cheapest option, but it would be unsafe and a waste of land.',
          },
        ],
      },
      {
        id: 2,
        level: 1,
        countInLevel: 2,
        text: 'The city\'s farming area is being used free of charge by a team of wealthy farmers for their cattle.  Whilst it is good for Mega City to have a city farm, which also promotes local produce, this space is needed for residential properties. As a <strong>Rural Surveyor</strong>, what would you recommend?',
        image: '/main--level_1_question_2.jpg',
        feedback_background: '/bg--level_1_new.jpg',
        feedbackTo: 'rural.surveyor@megacity123.co.uk',
        feedbackSubject: 'City farm recommendation',
        answered: false,
        answer: 2,
        responses: [
          {
            id: 1,
            text: 'Ask the farmers to move to another city - far away from the development.',
            score: 1,
            cost: 0,
            feedback: 'Thanks for your recommendation. There would be no cost involved if the farmers moved, but this may cause offence to a group of potential wealthy future investors.',
          },
          {
            id: 2,
            text: 'Negotiate with the farmers to move to the edge of the city. Offer to fund all of the costs to move.',
            score: 2,
            cost: 50000,
            feedback: 'Thanks for your recommendation. This would keep the farmers happy, but could prove to be expensive if the city paid for their relocation.',
          },
          {
            id: 3,
            text: 'Reduce the size of the farming land to keep the city farm, and create extra space for residential properties.',
            score: 3,
            cost: 15000,
            feedback: 'Thanks for your recommendation. This would be an excellent compromise, as it would keep the farmers reasonably happy and involve very low costs.',
          },
        ],
      },
      {
        id: 3,
        level: 1,
        countInLevel: 3,
        text: 'Before any planning and building can start in Mega City, you have been asked to provide an exact plan of the land. As a <strong>Geomatics Surveyor</strong>, how would you do this?',
        image: '/main--level_1_question_3.jpg',
        feedback_background: '/bg--level_1_new.jpg',
        feedbackTo: 'geomatics.surveyor@megacity123.co.uk',
        feedbackSubject: 'Planning recommendation',
        answered: false,
        answer: 0,
        responses: [
          {
            id: 1,
            text: 'Use a drone with aerial photography to measure the land. This would provide a detailed view of the land very quickly.',
            score: 3,
            cost: 5000,
            feedback: 'Thanks for your recommendation. Drones used in surveying are quite expensive, however most Geomatic surveying firms would already own one – so this is a relatively cheap option.',
          },
          {
            id: 2,
            text: 'Use existing plans of the area which are out of date.',
            score: 1,
            cost: 0,
            feedback: 'Thanks for your recommendation. The existing plans would cost nothing, but measurements can change over time so it\'s best to check before building starts.',
          },
          {
            id: 3,
            text: 'Use a ground penetrating vehicle to show underground images of the land.',
            score: 2,
            cost: 50000,
            feedback: 'Thanks for your recommendation. Using a ground penetrating vehicle is an expensive option, and may not provide the all of the details for an exact plan of the land.',
          },
        ],
      },
      {
        id: 4,
        level: 1,
        countInLevel: 4,
        text: 'Several reports of the land have been received. One report shows unused underground tunnels which may affect any new buildings that will be built on the land. As a <strong>Geomatics surveyor</strong> what should you do?',
        image: '/main--level_1_question_4.jpg',
        feedback_background: '/bg--level_1_new.jpg',
        feedbackTo: 'geomatics.surveyor@megacity123.co.uk',
        feedbackSubject: 'Underground tunnels recommendation',
        answered: false,
        answer: 0,
        responses: [
          {
            id: 1,
            text: 'Avoid building on the land where the tunnels are located.',
            score: 2,
            cost: 0,
            feedback: 'Thanks for your recommendation. Not building on the land where tunnels are located is a good idea, but as the population grows, you may need to use the land in the future.',
          },
          {
            id: 2,
            text: 'Ignore the report that shows the tunnels - the other reports show it will be fine.',
            score: 1,
            cost: 0,
            feedback: 'Thanks for your recommendation. Although ignoring the report has no cost, it is a very risky option and not advisable.',
          },
          {
            id: 3,
            text: 'Use a Small Unmanned Ground Vehicle (SUGV) to have an in-depth look around the tunnels.',
            score: 3,
            cost: 50000,
            feedback: 'Thanks for your recommendation. Using an SUGV to look around the tunnels would be expensive, but to avoid problems later you must carry out this form of report.',
          },
        ],
      },
      {
        id: 5,
        level: 2,
        countInLevel: 1,
        text: 'The water supply system has been fitted to provide the city with enough water. However, the population is likely to increase, which will cause a massive shortage in water. As an <strong>Environmental Surveyor</strong> what would you suggest?',
        image: '/main--level_2_question_1.jpg',
        feedback_background: '/bg--level_2_new.jpg',
        feedbackTo: 'environmental.surveyor@megacity123.co.uk',
        feedbackSubject: 'Water supply recommendation',
        answered: false,
        answer: 0,
        responses: [
          {
            id: 1,
            text: 'Hope the current water supply can keep up and put off investing in improving the current system. ',
            score: 1,
            cost: 0,
            feedback: 'Thanks for your recommendation. Leaving the current water supply will incur no extra costs, but would be risky and could cause big problems later.',
          },
          {
            id: 2,
            text: 'Explore how to gain a supply of water from offshore (at sea) water reserves.',
            score: 3,
            cost: 900000,
            feedback: 'Thanks for your recommendation. Using offshore water reserves is a costly option, but would provide enough water to supply the anticipated growing population.',
          },
          {
            id: 3,
            text: 'Construct all buildings with rain water filters and plant vegetation to provide a natural water supply.',
            score: 2,
            cost: 100000,
            feedback: 'Thanks for your recommendation. Using rain water filters and plant vegetation to provide water is a good option with relatively low costs, but is very dependent on the weather to provide enough rain water.',
          },
        ],
      },
      {
        id: 6,
        level: 2,
        countInLevel: 2,
        text: 'Mega City will have a large population, which will depend on a good internet supply to their homes. You are going to require a lot more power. As a <strong>Residential Surveyor</strong>, what would you suggest?',
        image: '/main--level_2_question_2.jpg',
        feedback_background: '/bg--level_2_new.jpg',
        feedbackTo: 'residential.surveyor@megacity123.co.uk',
        feedbackSubject: 'Internet supply upgrade',
        answered: false,
        answer: 0,
        responses: [
          {
            id: 1,
            text: 'Make no changes to the plans and leave the current supply as it is. If the residents want better connection, ask them to pay for it.  ',
            score: 1,
            cost: 0,
            feedback: 'Leaving the internet supply as it is wouldn\'t cost anything, but it could make it harder to sell the houses.',
          },
          {
            id: 2,
            text: 'Extend the current supply using the historic underground internet cabling.',
            score: 3,
            cost: 100000,
            feedback: 'Thanks for your suggestion. Using the historic underground internet cabling would boost the current supply at a reasonable cost.',
          },
          {
            id: 3,
            text: 'Remove all historic lines and install fibre optic cables, which  would offer a stronger, permanent and reliable connection.  ',
            score: 2,
            cost: 2000000,
            feedback: 'Thanks for your suggestion. Removing historic lines and installing fibre optic cables would be a very costly option, but would provide reliable and up-to-date technology.',
          },
        ],
      },
      {
        id: 7,
        level: 2,
        countInLevel: 3,
        text: 'An extensive transport network will be built to make it easier for people to move around the city. As a <strong>Planning and Development Surveyor</strong> it is your job to suggest ways to make the transport network environmentally friendly, particularly in the city centre. What would you suggest?',
        image: '/main--level_2_question_3.jpg',
        feedback_background: '/bg--level_2_new.jpg',
        feedbackTo: 'pandd.surveyor@megacity123.co.uk',
        feedbackSubject: 'New transport network',
        answered: false,
        answer: 0,
        responses: [
          {
            id: 1,
            text: 'Ban all vehicles, including emergency services from entering the city centre. Only allow bikes and pedestrians within this area.',
            score: 1,
            cost: 0,
            feedback: 'Thanks for your suggestion. Banning all vehicles from the city centre is a cheap option but would be dangerous with no emergency vehicles having access and inconvenient for those with mobility difficulties.',
          },
          {
            id: 2,
            text: 'Build a state of the art bridge with road sensor technology to take traffic away from the city centre.',
            score: 2,
            cost: 4000000,
            feedback: 'Thanks for your suggestion. Building a bridge to take traffic away from the city centre would be expensive but would help divert a lot of unnecessary traffic through the centre.',
          },
          {
            id: 3,
            text: 'Invest in an energy efficient inner-city tram network and limit the time that vehicles can drive through the city centre. ',
            score: 3,
            cost: 25000000,
            feedback: 'Thanks for your suggestion. Investing in an energy efficient inner-city tram network is an expensive option but very effective. Trams are pollution free so air quality would be improved!',
          },
        ],
      },
      {
        id: 8,
        level: 2,
        countInLevel: 4,
        text: 'Mega City\'s financial district has attracted lots of interest from businesses that would like to invest in the area. However, the space has already been planned for current investors. As a <strong>Management Consultancy Surveyor</strong> what should you do.',
        image: '/main--level_2_question_4.jpg',
        feedback_background: '/bg--level_2_new.jpg',
        feedbackTo: 'mgmtcons.surveyor@megacity123.co.uk',
        feedbackSubject: 'Financial district planning recommendation',
        answered: false,
        answer: 0,
        responses: [
          {
            id: 1,
            text: 'Forget about the current investors and offer the space to those who are willing to invest the most.',
            score: 1,
            cost: 0,
            feedback: 'Thanks for your recommendation. Offering the space to those who are willing to invest most may be the best short term option but you need to retain the loyalty with investors for future projects.',
          },
          {
            id: 2,
            text: 'Reconsider the building plans and \'build up\' to create tall buildings that overshadow the city\'s art museum.',
            score: 2,
            cost: 2000000,
            feedback: 'Thanks for your recommendation. \'Building up\' would meet demand for more office space in the financial district, but would overshadow a tourist attraction.',
          },
          {
            id: 3,
            text: 'Encourage businesses to share the existing space, offering flexible working to best use the space.',
            score: 3,
            cost: 25000,
            feedback: 'Thanks for your recommendation. Encouraging businesses to share is an excellent option with low costs and keeps the landscape free of buildings that are too high.',
          },
        ],
      },
      {
        id: 9,
        level: 3,
        countInLevel: 1,
        text: 'Mega City would like to ensure an environmentally friendly supply of food and drink to the city\'s vibrant restaurant industry. As an <strong>Infrastructure Surveyor</strong>, how would you solve this problem?',
        image: '/main--level_3_question_1.jpg',
        feedback_background: '/bg--level_3_new.jpg',
        feedbackTo: 'infrastructure.surveyor@megacity123.co.uk',
        feedbackSubject: 'Food &amp; drink supply recommendation',
        answered: false,
        answer: 0,
        responses: [
          {
            id: 1,
            text: 'Rebuild the transport network to bring in more supplies to restaurants. Split this expensive cost between the restaurant owners.',
            score: 2,
            cost: 30000000,
            feedback: 'Thanks for your recommendation. Although the costs of rebuilding the transport network would be shared, restaurant owners would be unlikely to pay for this.',
          },
          {
            id: 2,
            text: 'Bring in additional food and drink supplies to the city by using an un-used waterway - an environmentally friendly option. ',
            score: 3,
            cost: 1000000,
            feedback: 'Thanks for your recommendation. Using an un-used waterway would be costly, but very effective option, as large amounts of supplies could be shipped in.',
          },
          {
            id: 3,
            text: 'Build an extra runway at the airport, which just brings in commercial goods.',
            score: 1,
            cost: 15000000,
            feedback: 'Thanks for your recommendation. Building an extra runway would be costly and increase pollution and noise. This would not be environmentally-friendly.',
          },
        ],
      },
      {
        id: 10,
        level: 3,
        countInLevel: 2,
        text: 'Mega City has secured a social housing organisation who have a limited budget but offer good quality homes. They have based their costings on using reasonably priced materials that have varied life spans. As a <strong>Quantity Surveyor</strong> you need to make sure the materials are cost effective and fit for purpose.',
        image: '/main--level_3_question_2.jpg',
        feedback_background: '/bg--level_3_new.jpg',
        feedbackTo: 'quantity.surveyor@megacity123.co.uk',
        feedbackSubject: 'Social housing recommendation',
        answered: false,
        answer: 0,
        responses: [
          {
            id: 1,
            text: 'Select the cheapest products with the shortest life cycle to be as cost effective as possible.',
            score: 1,
            cost: 25000,
            feedback: 'Thanks for your recommendation. Selecting the cheapest products with the shortest life cycle would be cost effective, but further works would be required later and increase longer term costs.',
          },
          {
            id: 2,
            text: 'Recommend the more expensive products that will last longer.  ',
            score: 3,
            cost: 50000,
            feedback: 'Thanks for your recommendation. Choosing more expensive products that last longer will cost more upfront, but provide the most cost-effective solution over 15 years.',
          },
          {
            id: 3,
            text: 'Build the houses using 3D printing - this will mean investing in new costly equipment, but houses can be built quickly and cheaply.',
            score: 2,
            cost: 5000000,
            feedback: 'Thanks for your recommendation. Using a 3D printer to build the houses has a large cost, but is a worthwhile investment if you will be building lots of low-cost housing.',
          },
        ],
      },
      {
        id: 11,
        level: 3,
        countInLevel: 3,
        text: 'A sports team has shown an interest in Mega City. They want to build a large multi-purpose sports complex, which would attract more visitors to the city. Space is limited, and priority has been given to solve a housing shortage. As a <strong>Project Management Surveyor</strong> you will need to agree what to do.',
        image: '/main--level_3_question_3.jpg',
        feedback_background: '/bg--level_3_new.jpg',
        feedbackTo: 'project-mgmt-surveyor@megacity123.co.uk',
        feedbackSubject: 'New sports complex',
        answered: false,
        answer: 0,
        responses: [
          {
            id: 1,
            text: 'Design and construct a suitable multi-purpose sports complex with state-of-the-art modern features, with no housing options.',
            score: 2,
            cost: 50000000,
            feedback: 'Thanks for your suggestion. Designing a complex with state-of-the-art modern features is expensive and does not solve the housing shortage, but would have a \'wow factor\' attracting more visitors to the city.',
          },
          {
            id: 2,
            text: 'Build a limited-sized complex which involves housing for people to live in. The building would be built with sound-proofing materials.',
            score: 3,
            cost: 60000000,
            feedback: 'Thanks for your suggestion. Building a complex with homes for people to live in is a good option. Although there will be greater costs, more visitors will be attracted to the city, whilst also helping with the housing shortage.',
          },
          {
            id: 3,
            text: 'Encourage the building of the stadium outside of the city, which will allow houses to be built in the centre.',
            score: 1,
            cost: 20000000,
            feedback: 'Thanks for your suggestion. Building the stadium outside the city is cost effective, but would not attract people to the city and you could lose the stadium\'s investor who wants it to be in the city.',
          },
        ],
      },
      {
        id: 12,
        level: 3,
        countInLevel: 4,
        text: 'The population is growing and the city\'s hospital needs to increase the number of bed spaces for patients, but funding is limited. As a <strong>Valuation Surveyor</strong>, Mega City Council has asked you to value the land the hospital currently occupies to see what is the best option.',
        image: '/main--level_3_question_4.jpg',
        // ADDED PJC 20/11/2018
        feedback_background: '/bg--level_3_new.jpg',
        // ADDED PJC 20/11/2018
        feedbackTo: 'valuation.surveyor@megacity123.co.uk',
        // ADDED PJC 20/11/2018
        feedbackSubject: 'Valuation',
        answered: false,
        answer: 0,
        responses: [
          {
            id: 1,
            text: 'Value the hospital and advise the council to build an additional wing for private patients only.',
            score: 1,
            cost: 0,
            feedback: 'Thanks for your valuation. This is a good option providing there are patients willing to pay for treatment. By having paying patients, this will enable an extra wing to be built.',
          },
          {
            id: 2,
            text: 'Value the land where the hospital is. As it is in the city centre this is likely to be of high value. Advise the council to sell the land and build a new hospital with extra beds out of the city centre.',
            score: 3,
            cost: 5000000,
            feedback: 'Thanks for your valuation. This is a good option. Moving the hospital out of the city centre will allow greater potential for investors in new buildings on the land. However, it will mean the patients will need to travel further for treatment.',
          },
          {
            id: 3,
            text: 'Value the hospital and advise the council to upgrade their use of technology, which may result in reduced waiting times and less need for bed spaces.',
            score: 2,
            cost: 10000000,
            feedback: 'Thanks for your valuation. Upgrading the hospital\'s use of technology is a good option, because it may result in reducing the length of stay for patients and less need for bed spaces.',
          },
        ],
      },
      {
        id: 13,
        level: 4,
        countInLevel: 1,
        text: 'The city\'s entertainment complex needs a good balance of shops, virtual reality hubs, restaurants and leisure facilities. It also needs easy access to transport links. You are shown three different designs using Building Information Modelling (BIM).  As a <strong>Commercial Surveyor</strong>, which option do you choose?',
        image: '/main--level_4_question_1.jpg',
        feedback_background: '/bg--level_4_new.jpg',
        feedbackTo: 'commercial.surveyor@megacity123.co.uk',
        feedbackSubject: 'Shopping centre recommendation',
        answered: false,
        answer: 0,
        responses: [
          {
            id: 1,
            text: 'BIM Design 1 - 30% entertainment - 40% retail shops -  20% leisure facilities - 10% restaurants. Designed to have easy access to buses and all other transport links.',
            score: 2,
            cost: 20000000,
            feedback: 'Thanks for your recommendation. BIM Design 1 has a good mix of facilities, however the balance isn\'t right as there will be fewer traditional shops in the future so you need to allow for more virtual reality hubs allowing the public to \'try before they buy\' as a virtual experience.',
          },
          {
            id: 2,
            text: 'BIM Design 2 - 50% entertainment - 10% retail shops - 10% leisure facilities - 10% virtual reality shopping spaces - 20% restaurants.  Easy access to transport links are being developed.',
            score: 3,
            cost: 20000000,
            feedback: 'Thanks for your recommendation. BIM Design 2 has a good balance between all facilities, including new virtual reality shopping spaces and planned transport links.',
          },
          {
            id: 3,
            text: 'BIM Design 3 - 50% entertainment - 40% retail shops - 10% leisure facilities. No restaurants. There are no plans to increase travel links.',
            score: 1,
            cost: 20000000,
            feedback: 'Thanks for your recommendation. BIM Design 3 has a poor balance of facilities and public transport is not available. There will also be less traditional shops in the future.',
          },
        ],
      },
      {
        id: 14,
        level: 4,
        countInLevel: 2,
        text: 'A high rise apartment block has a fault in the waste management system. It is giving off poisonous levels of methane gas, which is going to take several days to fix. <strong>Urgent action</strong> needs to take place! As a <strong>Facilities Management Surveyor</strong> what would you suggest?',
        image: '/main--level_4_question_2.jpg',
        feedback_background: '/bg--level_4_new.jpg',
        feedbackTo: 'facilities-mgmt-surveyor@megacity123.co.uk',
        feedbackSubject: 'Waste management issue',
        answered: false,
        answer: 0,
        responses: [
          {
            id: 1,
            text: 'Gather together a team to talk about how the waste system can be fixed.',
            score: 1,
            cost: 0,
            feedback: 'Thanks for your suggestion. Although discussing how the waste system can be fixed is a good option, no action is taking place, so it risks people\'s health.',
          },
          {
            id: 2,
            text: 'Arrange for the residents to be moved to an alternative location immediately whilst the system is being fixed. ',
            score: 3,
            cost: 50000,
            feedback: 'Thanks for your suggestion. Moving the residents would create some extra costs, but would ensure the residents are safe which is the main priority.',
          },
          {
            id: 3,
            text: 'Install a back up system at whatever cost.',
            score: 2,
            cost: 90000,
            feedback: 'Thanks for your suggestion. Installing a backup system is expensive; it solves the problem immediately, but may not be necessary if the old system can be fixed.',
          },
        ],
      },
      {
        id: 15,
        level: 4,
        countInLevel: 3,
        text: 'Due to advances in technology and the introduction of artificial intelligence (AI), the way students are being taught is changing. You need to make one of the following options a priority. As a <strong>Building Surveyor</strong> what do you do?',
        image: '/main--level_4_question_3.jpg',
        feedback_background: '/bg--level_4_new.jpg',
        feedbackTo: 'building.surveyor@megacity123.co.uk',
        feedbackSubject: 'Schools recommendation',
        answered: false,
        answer: 0,
        responses: [
          {
            id: 1,
            text: 'Keep teaching in the same way without AI. The students will still be learning, even if the most up to date technology is not being used.',
            score: 2,
            cost: 0,
            feedback: 'Thanks for your recommendation. By teaching in the same way, it does not take advantage of innovative ways students can learn using sophisticated technology, and schools will take up a lot of space.',

          },
          {
            id: 2,
            text: 'Teach students using \'virtual\' classrooms, technology tables and face to face learning within schools and homes.',
            score: 3,
            cost: 70000,
            feedback: 'Thanks for your recommendation. Offering a range of learning opportunities with AI technology, ensures the use of new technologies.',
          },
          {
            id: 3,
            text: 'Bring hologram teachers into the homes of students and remove all buildings used for schools completely. ',
            score: 1,
            cost: 12000000,
            feedback: 'Thanks for your recommendation. Using hologram teachers has a huge cost associated with it and may not work because not every student will have the latest technology in their homes.',
          },
        ],
      },
      {
        id: 16,
        level: 4,
        countInLevel: 4,
        text: 'Mega City wants to keep up with the latest technology, particularly for its transport networks. Driverless cars are now in high demand. As an <strong>Infrastructure Surveyor</strong> you have been asked to look at how the current road system can be adapted for driverless cars.',
        image: '/main--level_4_question_4.jpg',
        feedback_background: '/bg--level_4_new.jpg',
        feedbackTo: 'infrastructure.surveyor@megacity123.co.uk',
        feedbackSubject: 'Road systems recommendation',
        answered: false,
        answer: 0,
        responses: [
          {
            id: 1,
            text: 'Keep the existing road network. Driverless cars should be used to fit around the city\'s existing way of life.',
            score: 1,
            cost: 0,
            feedback: 'Thanks for your recommendation. Keeping the existing road network has no cost but does not help your city become smart and fit for the future.',

          },
          {
            id: 2,
            text: 'Redesign all the roads and transport systems to make them smart and suitable for driverless cars - this is the future of travel!',
            score: 3,
            cost: 15000000,
            feedback: 'Thanks for your recommendation. Redesigning all of the roads and transport systems is a costly option, but would ensure the city keeps up with technology.',
          },
          {
            id: 3,
            text: 'Reduce the amount of car parks to free up the space for re-development.',
            score: 2,
            cost: 10000000,
            feedback: 'Thanks for your recommendation. Reducing the car parks may increase opportunities for property development, but development may block the routes for driverless cars.',
          },
        ],
      },
    ],
    careers: [
      {
        name: 'Building Surveyor',
        category: 'map',
        document: '/Career_profiles_SamOrgan.pdf',
      },
      {
        name: 'Rural Surveyor',
        category: 'map',
        document: '/Career_profiles_DavinaFillingham.pdf',
      },
      {
        name: 'Geomatics Surveyor',
        category: 'map',
        document: '/Career_profiles_CharltonBland.pdf',
      },
      {
        name: 'Environmental Surveyor',
        category: 'design',
        document: '/Career_profiles_DavidInman.pdf',
      },
      {
        name: 'Residential Surveyor',
        category: 'design',
        document: '/Career_profiles_HelenJones.pdf',
      },
      {
        name: 'Planning and Development Surveyor',
        category: 'design',
        document: '/Career_profiles_TheoTill.pdf',
      },
      {
        name: 'Quantity Surveyor',
        category: 'build',
        document: '/Career_profiles_StephanieMarshall.pdf',
      },
      {
        name: 'Project Management Surveyor',
        category: 'build',
        document: '/Career_profiles_ShyhamVisavadia.pdf',
      },
      {
        name: 'Valuation Surveyor',
        category: 'build',
        document: '/Career_profiles_HelenaTibbitts.pdf',
      },
      {
        name: 'Commercial Surveyor',
        category: 'manage',
        document: '/Career_profiles_FaithLocken.pdf',
      },
      {
        name: 'Facilities Management Surveyor',
        category: 'manage',
        document: '/Career_profiles_NicolaDixonBrown.pdf',
      },
      {
        name: 'Infrastructure Surveyor',
        category: 'manage',
        document: '/Career_profiles_KimberlyHepburn.pdf',
      },
    ],
    ranks: [
      {
        rank_name: 'Apprentice',
        rank_level: 1,
        rank_achieveAt: 0,
        rank_achieved: true,
      },
      {
        rank_name: 'Junior Surveyor',
        rank_level: 2,
        rank_achieveAt: 12,
        rank_achieved: false,
      },
      {
        rank_name: 'Associate',
        rank_level: 3,
        rank_achieveAt: 36,
        rank_achieved: false,
      },
      {
        rank_name: 'Partner',
        rank_level: 4,
        rank_achieveAt: 45,
        rank_achieved: false,
      },
    ],
  },
  mutations: {
    // user mutations
    adjustBudget(state, payload) {
      state.user.budget -= payload;
    },
    increaseRank(state) {
      state.user.rank += 1;
    },
    increaseLevel(state) {
      state.user.level += 1;
    },
    setShowPromotionStatus(state, payload) {
      state.user.showPromotion = payload;
    },
    setGameOverStatus(state, payload) {
      state.user.gameOver = payload;
    },
    setLevel(state, payload) {
      state.user.level = payload;
    },
    updateStartConfidence(state, payload) {
      state.user.startConfidence = payload;
      return state.user.startConfidence;
    },
    updateEndConfidence(state, payload) {
      state.user.endConfidence = payload;
    },
    updateRecommendAFriend(state, payload) {
      state.user.recommendAFriend = payload;
    },
    updatePursueCareer(state, payload) {
      state.user.pursueCareer = payload;
    },
    resetStartConfidence(state) {
      state.user.startConfidence = 0;
    },
    resetEndConfidence(state) {
      state.user.endConfidence = 0;
    },
    resetPersueCareer(state) {
      state.user.persueCareer = 0;
    },
    resetRank(state) {
      state.user.rank = 1;
    },
    resetQuestion(state) {
      state.user.question = 0;
    },
    resetScore(state) {
      state.user.score = 0;
    },
    saveScore(state, payload) {
      state.user.score += payload;
    },
    resetBudget(state) {
      state.user.budget = 130000000;
    },
    resetPromotion(state) {
      state.user.showPromotion = false;
    },
    resetGameOver(state) {
      state.user.gameOver = false;
    },
    resetLevel(state) {
      state.user.level = 1;
    },
    // eslint-disable-next-line
    resetAnswers(state) {
      const questions = state.questions;
      for (let index = 0; index < questions.length; index += 1) {
        const question = questions[index];
        question.answer = 0;
        question.answered = false;
      }
    },
    showFeedback(state, payload) {
      const level = state.user.level;
      // eslint-disable-next-line
      const result = state.questions.filter(function (v) {
        return (v.level === level && v.countInLevel === payload);
      });
      result[0].showFeedback = !result[0].showFeedback;
    },
    saveAnswer(state, payload) {
      const q = this.getters.getCurrentQuestion(payload[0]);
      q.answered = true;
      q.answer = payload[1];
    },
    setQuestionTracker(state, payload) {
      state.user.question = payload;
    },
    incrementQuestionIndex(state) {
      state.user.questionIndex += 1;
    },
    resetQuestionIndex(state) {
      state.user.questionIndex = 0;
    },
    toggleShowTips(state) {
      state.user.showTips = !state.user.showTips;
    },
    // firebase mutations
    setFirebaseUser(state, payload) {
      state.firebase.user = payload;
    },
    setFirebaseError(state, payload) {
      state.firebase.error = payload;
    },
    setFirebaseLoading(state, payload) {
      state.firebase.loading = payload;
    },
  },
  methods: {
    // incrementTime() {},
  },
  getters: {
    getUser: state => state.user,
    getLevel: state => state.user.level,
    getAllLevels: state => state.levels,
    getCurrentLevelDetail: state => payload => state.levels.find(level => level.level === payload),
    getCurrentQuestion: state => payload =>
      state.questions.find(question => question.id === payload),
    getBudget: state => state.user.budget,
    getScore: state => state.user.score,
    getRank: state => state.user.rank,
    getShowPromotionStatus: state => state.user.showPromotion,
    getGameOverStatus: state => state.user.gameOver,
    getQuestionTracker: state => state.user.question,
    getQuestionIndex: state => state.user.questionIndex,
    getAllQuestions: state => state.questions,
    getCurrentQuestions: state => payload =>
      state.questions.find(questions => questions.level === payload),
    getRankName: state => payload => state.ranks.find(rankName => rankName.rank_level === payload),
    getAllCareers: state => state.careers,
    getCareer: state => payload => state.careers.find(career => career.slug === payload),
    getStartConfidence: state => state.user.startConfidence,
    getEndConfidence: state => state.user.endConfidence,
    getRecommendAFriend: state => state.user.recommendAFriend,
    getImageDomain: state => state.app.imageDomain,
    getDocumentDomain: state => state.app.documentDomain,
    getShowTips: state => state.user.showTips,
  },
  actions: {
    adjustBudget({ commit }, payload) {
      commit('adjustBudget', payload);
    },
    increaseRank({ commit }) {
      commit('increaseRank');
    },
    setShowPromotionStatus({ commit }, payload) {
      commit('setShowPromotionStatus', payload);
    },
    setGameOverStatus({ commit }, payload) {
      commit('setGameOverStatus', payload);
    },
    increaseLevel({ commit }) {
      commit('increaseLevel');
    },
    setLevel({ commit }, payload) {
      commit('setLevel', payload);
    },
    updateStartConfidence({ commit }, payload) {
      commit('updateStartConfidence', payload);
    },
    updateEndConfidence({ commit }, payload) {
      commit('updateEndConfidence', payload);
    },
    updatePursueCareer({ commit }, payload) {
      commit('updatePursueCareer', payload);
    },
    resetUser({ commit }) {
      commit('resetStartConfidence');
      commit('resetEndConfidence');
      commit('resetRank');
      commit('resetQuestion');
      commit('resetScore');
      commit('resetBudget');
    },
    resetState({ commit }) {
      commit('resetScore');
      commit('resetBudget');
      commit('resetRank');
      commit('resetPromotion');
      commit('resetGameOver');
      commit('resetLevel');
      commit('resetQuestion');
      commit('resetQuestionIndex');
      commit('resetStartConfidence');
      commit('resetEndConfidence');
      commit('resetPersueCareer');
      commit('resetAnswers');
    },
    updateRecommendAFriend({ commit }, payload) {
      commit('updateRecommendAFriend', payload);
    },
    saveScore({ commit }, payload) {
      commit('saveScore', payload);
    },
    showFeedback({ commit }, payload) {
      commit('showFeedback', payload);
    },
    saveAnswer({ commit }, payload) {
      commit('saveAnswer', payload);
    },
    setQuestionTracker({ commit }, payload) {
      commit('setQuestionTracker', payload);
    },
    incrementQuestionIndex({ commit }) {
      commit('incrementQuestionIndex');
    },
    resetQuestionIndex({ commit }) {
      commit('resetQuestionIndex');
    },
    toggleShowTips({ commit }) {
      commit('toggleShowTips');
    },
    authenticateFirebase() {
      // eslint-disable-next-line
      firebase.auth().signInAnonymously().catch(error => console.log(error));
    },
    storeResponsesInFirebase() {
      const messageListRef = firebase.database().ref('responses/');
      const newMessageRef = messageListRef.push();
      newMessageRef.set({
        startConfidence: this.state.user.startConfidence,
        endConfidence: this.state.user.endConfidence,
        pursueCareer: this.state.user.pursueCareer,
        score: this.state.user.score,
        rank: this.state.user.rank,
        budget: this.state.user.budget,
        timestamp: firebase.database.ServerValue.TIMESTAMP,
      });
    },
    // firebase
    userSignUp({ commit }) {
      commit('setFirebaseLoading', true);
      // eslint-disable-next-line
      firebase.auth().signInAnonymously().catch(function (error) {
        // eslint-disable-next-line
        var errorCode = error.code;
        // eslint-disable-next-line
        var errorMessage = error.message;
      });

      // const database = firebase.database();
      // console.log(database);

      // firebase.database().ref('responses/' + firebase.auth().currentUser.uid).set({
      //   username: 'test',
      //   email: 'test@test.com',
      // });
      const messageListRef = firebase.database().ref('responses/');
      const newMessageRef = messageListRef.push();
      newMessageRef.set({
        startConfidence: this.state.user.startConfidence,
        endConfidence: this.state.user.endConfidence,
        pursueCareer: this.state.user.pursueCareer,
        score: this.state.user.score,
        rank: this.state.user.rank,
        budget: this.state.user.budget,
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/store.js